import { actionForState } from "../../common/functions/utils";

import {
    GET_ACTIVITY_LIST,
    DELETE_ACTIVITY,
    DELETE_ALL_ACTIVITIES,
} from './types';

import { toast } from "react-toastify";
toast.configure();

export const INITIAL_STATE = {
    activities: [],
    actionForGetActivityList: {
        loading: false,
        success: false,
        error: false,
    },
    actionForDeleteActivity: {
        loading: false,
        success: false,
        error: false,
    },
    actionForDeleteMultipleActivities: {
        loading: false,
        success: false,
        error: false,
    },
}

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {

        case GET_ACTIVITY_LIST.pending:
            return {
                ...state,
                actionForGetActivityList: actionForState(state.action, 'pending'),
            }
        case GET_ACTIVITY_LIST.success:
            return {
                ...state,
                activities: action.payload.data,
                actionForGetActivityList: actionForState(state.action, 'success'),
            }
        case GET_ACTIVITY_LIST.error:
            toast.error(action.payload.message);
            return {
                ...state,
                actionForGetActivityList: actionForState(state.action, 'error', action.payload.message),
            }

        case DELETE_ACTIVITY.pending:
            return {
                ...state,
                actionForDeleteActivity: actionForState(state.action, 'pending'),
            }
        case DELETE_ACTIVITY.success:
            toast.success("Activity has been successfully deleted.");
            return {
                ...state,
                activities: state.activities.filter(activity => activity.id !== Number(action.payload.id)),
                actionForDeleteActivity: actionForState(state.action, 'success'),
            }
        case DELETE_ACTIVITY.error:
            toast.error(action.payload.message)
            return {
                ...state,
                actionForDeleteActivity: actionForState(state.action, 'error', action.payload.message),
            }

        case DELETE_ALL_ACTIVITIES.pending:
            return {
                ...state,
                actionForDeleteMultipleActivities: actionForState(state.action, 'pending'),
            }
        case DELETE_ALL_ACTIVITIES.success:
            toast.success("All activities have been deleted successfully.");
            return {
                ...state,
                activities: [],
                actionForDeleteMultipleActivities: actionForState(state.action, 'success'),
            }
        case DELETE_ALL_ACTIVITIES.error:
            toast.error(action.payload.message)
            return {
                ...state,
                actionForDeleteMultipleActivities: actionForState(state.action, 'error', action.payload.message),
            }
        
        default:
            return state;
    }
}